"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castellana-sicula": {
    "41e5f743": [{
      "hkey": "d2e2471a",
      "slug": "castellana-sicula",
      "name": "Castellana Sicula",
      "primary": true,
      "skipSearch": false
    }],
    "centri-abitati-calcarelli": [{
      "hkey": "d2e2471a",
      "slug": "castellana-sicula",
      "name": "Castellana Sicula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "17f2d3c6": [{
      "hkey": "d2e2471a",
      "slug": "castellana-sicula",
      "name": "Castellana Sicula",
      "primary": true,
      "skipSearch": false
    }],
    "donalegge": [{
      "hkey": "d2e2471a",
      "slug": "castellana-sicula",
      "name": "Castellana Sicula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "57cab33c": [{
      "hkey": "d2e2471a",
      "slug": "castellana-sicula",
      "name": "Castellana Sicula",
      "primary": true,
      "skipSearch": false
    }],
    "tudia": [{
      "hkey": "d2e2471a",
      "slug": "castellana-sicula",
      "name": "Castellana Sicula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5ccc7169": [{
      "hkey": "d2e2471a",
      "slug": "castellana-sicula",
      "name": "Castellana Sicula",
      "primary": true,
      "skipSearch": false
    }],
    "xireni": [{
      "hkey": "d2e2471a",
      "slug": "castellana-sicula",
      "name": "Castellana Sicula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;